<template>

  <div id="examDetail" v-show="show">
    <exam-header ></exam-header>
    <el-row>
      <el-col :span="12"  :offset="6">
        <div class="exam-detail" >
         <!-- <h3 class="title" >{{params.type == '0'?'新人入司考试':params.type ==='NEW_RISK'?'新人险种试卷':'地区入司考试'}}</h3> -->
          <div h3 class="title">{{typeFix(params.type)}}</div>
          <div class="container">
            <el-row>
              <el-col :span="12"  class="content-div right-border">时长：{{examInfo.totalTime}}分钟</el-col>
              <el-col :span="12"  class="content-div ">题量：{{examInfo.questionCount}}题</el-col>
            </el-row>
             <el-row>
              <el-col :span="12"  class="content-div right-border">满分：{{examInfo.totalsCore}}分</el-col>
              <el-col :span="12"  class="content-div ">及格：{{examInfo.passingGrade}}分</el-col>
            </el-row>
            <div><p class="tip">友情提示：请在5分钟之内开始考试。</p></div>
             <el-button type="primary" @click="start"  class="btn">
                开始考试
            </el-button>
            <div><p class="tip font-blue"  @click="goToChoose()">重新选择试卷</p></div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import api from '@/modules/api.js'
import session from '@/components/cache'
import examHeader from '@/layout/ExamHeader.vue'
import {showFullScreenLoading, tryHideFullScreenLoading} from '@/components/utils/loading.js'
export default {
  components: {examHeader},
  data () {
    return {
      examInfo: {},
      params: {
        manageCom: '',
        type: '',
        businessNo: ''
      },
      req: {
        businessNo: '',
        paperType: null
      },
      show: false
    }
  },
  mounted () {
    this.params.manageCom = session.session_get('manageCom')
    this.params.type = this.$route.query.type
    this.req.paperType = new String(this.$route.query.type)
    this.params.businessNo = session.session_get('businessNo')
    this.req.businessNo = this.params.businessNo
    // todo... this.$app.NaviInit.init('入司考试')
    let that = this
    // 获取考试信息
    showFullScreenLoading()
    api.getExamInfo(this.params, function (res) {
      if (res.result.isSuccess === true) {
        tryHideFullScreenLoading()
        that.examInfo = res.data
        session.session_set('passingGrade',res.data.passingGrade)
        that.show = true
      } else {
        tryHideFullScreenLoading()
        that.$message.error(res.result.error)
      }
    })
  },
  methods: {
    typeFix(type){
      if(type == 0){
        return '新人入司考试'
      } else if(type == 'NEW_RISK'){
        return '新人险种考试'
      }else if(type == 'INTERNET'){
        return '互联网宣传和销售资质考试'
      }else{
        return '地区入司考试'
      }
    },
    start () {
      // let that = this
      // api.post(this.$url.checkLoginState, this.req, function (res) {
      //   if (res.data === 2 || res.data === 3) {
      //     console.log('未失效')
      //     // 验证5分钟是否失效
      //     api.post(that.$url.fiveMinCheck, that.req, function (res) {
      //       if (res.result.isSuccess === true) {
      //         if (res.data === true) { // 未失效
      //           that.$router.push({name: 'Exam', query: {type: that.params.type}})
      //         } else { // 失效
      //           that.$router.push({name: 'examLogin', params: {vaild: 'out'}})
      //         }
      //       } else {
      //         that.$message.error(res.result.error)
      //       }
      //     })
      //   } else {
      //     that.$router.push({name: 'examLogin', params: {vaild: 'out'}})
      //   }
      // })
      let that = this
      showFullScreenLoading()
      api.post(this.$url.checkLoginState,this.req, function (res) {
        if (res.data === 2 || res.data === 3) {
          tryHideFullScreenLoading()
          // 验证5分钟是否失效
          api.fiveMinCheck(that.req, function (res) {
            if (res.result.isSuccess === true) {
              if (res.data === true) { // 未失效
                that.$router.push({name: 'Exam', query: {type: that.params.type}})
              } else { // 失效
                console.log('失效')
                that.$router.push({name: 'examLogin'})
              }
            } else {
              that.$message.error(res.result.error)
            }
          })
        } else {
          // 未验证过,返回
          tryHideFullScreenLoading()
          that.$router.push({name: 'examLogin', query: {}})
        }
      })
    },
    goToChoose () {
      this.$router.push({name: 'examChooseTest'})
    }
  }
}
</script>
<style scoped>
.title{
    text-align: center;
    /* color: #194793; */
    margin: 20px 0px 50px 0

}
.exam-detail{
  border: solid 1px #D4DEE9;
  padding: 20px 50px 50px 50px;
  border-radius: 3%;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 100px;
}
.container{
    width: 90%;
    margin: 50px 5% 0 5%;
    text-align: center;
}
.content-div{

  text-align: center;
  margin-bottom: 25px
}
.right-border{
  border-right:1px solid #DFDFDF;
}
.tip{
  font-size: 12px;
  color: #FF6969;
  margin: 0 0 20px 0;
}
.btn{
  background-color:#C2A66E;
  border-color:#C2A66E;
  width: 100%;
}
.font-blue{
  color: #002C76;
  margin-top: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examDetail.vue